var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_65591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 4.66602C3.5 3.73776 3.86875 2.84752 4.52513 2.19114C5.1815 1.53476 6.07174 1.16602 7 1.16602C7.92826 1.16602 8.8185 1.53476 9.47487 2.19114C10.1313 2.84752 10.5 3.73776 10.5 4.66602C10.5 8.74935 12.25 9.91602 12.25 9.91602H1.75C1.75 9.91602 3.5 8.74935 3.5 4.66602Z",
    stroke: "#0064E0",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00879 12.25C6.10643 12.4276 6.24997 12.5757 6.42441 12.6789C6.59885 12.782 6.79779 12.8364 7.00046 12.8364C7.20312 12.8364 7.40206 12.782 7.5765 12.6789C7.75094 12.5757 7.89448 12.4276 7.99212 12.25",
    stroke: "#0064E0",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33366 1.16602C1.63366 2.15768 1.16699 3.32435 1.16699 4.66602",
    stroke: "#0064E0",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8337 4.66602C12.8337 3.32435 12.367 2.15768 11.667 1.16602",
    stroke: "#0064E0",
    strokeWidth: 1.02083,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_65591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBlue);
export default __webpack_public_path__ + "static/media/BellBlue.da0a1386354a08dfeb2b0030c91a1dc9.svg";
export { ForwardRef as ReactComponent };